<div class="tw-flex tw-gap-1 tw-justify-start" [pTooltip]="userId">
  <img [src]="profile?.ImageUrl" class="tw-w-10 tw-rounded-full">
  <div class="tw-flex tw-flex-col">
    <div>
      {{profile?.Name || userId || 'Guest'}}
    </div>
    <div class="tw-text-sm">
      {{identity?.Email}}
    </div>
    <div class="tw-text-sm">
      {{identity?.PhoneNumber}}
    </div>
  </div>
</div>
